import React from 'react';
import {
  OuterWrapper,
  BulletWrapper,
  BulletNumber,
  Title,
  Text,
  Link,
} from './elements';
import { type Tool } from 'account/module/modules/timeline/types';

type ToTlProps = {
  readonly border: boolean;
  readonly state: Tool['state'];
  readonly number: number;
  readonly title: string;
  readonly text?: string;
  readonly linkOneOnClick: () => void;
  readonly linkOneText: string;
  readonly linkTwoUrl?: string;
  readonly linkTwoText?: string;
};

function ToTl({
  border,
  state,
  number,
  title,
  text,
  linkOneOnClick,
  linkOneText,
  linkTwoUrl,
  linkTwoText,
}: ToTlProps) {
  return (
    <OuterWrapper $border={border} $state={state}>
      <BulletWrapper $state={state}>
        <BulletNumber $state={state}>{number}</BulletNumber>
      </BulletWrapper>
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Link onClick={linkOneOnClick}>{linkOneText}</Link>
      <a href={linkTwoUrl}>
        <Link>{linkTwoText}</Link>
      </a>
    </OuterWrapper>
  );
}

export default ToTl;
